import type { ViewFilter } from "./types/customViews";

/**
 * Compare deux ViewFilter pour vérifier s'ils sont identiques
 */
export function viewFiltersAreSame(
    filter1: ViewFilter,
    filter2: ViewFilter,
): boolean {
    // Comparer les tableaux keywords (obligatoire)
    if (!areArraysEqual(filter1.keywords, filter2.keywords)) {
        return false;
    }

    // Comparer startDate et endDate
    if (filter1.startDate !== filter2.startDate) {
        return false;
    }

    if (filter1.endDate !== filter2.endDate) {
        return false;
    }

    // Comparer identifiedSenders (optionnel)
    if (!areArraysEqual(filter1.identifiedSenders, filter2.identifiedSenders)) {
        return false;
    }

    // Comparer identifiedRecipients (optionnel)
    if (
        !areArraysEqual(
            filter1.identifiedRecipients,
            filter2.identifiedRecipients,
        )
    ) {
        return false;
    }

    // Comparer categories (optionnel)
    if (!areArraysEqual(filter1.categories, filter2.categories)) {
        return false;
    }

    // Comparer readStatus (optionnel)
    if (filter1.readStatus !== filter2.readStatus) {
        return false;
    }

    // Comparer hasAttachment (optionnel)
    if (filter1.hasAttachment !== filter2.hasAttachment) {
        return false;
    }

    // Comparer mailStatus (optionnel)
    if (!areArraysEqual(filter1.mailStatus, filter2.mailStatus)) {
        return false;
    }

    // Comparer sortOrder (obligatoire)
    if (filter1.sortOrder !== filter2.sortOrder) {
        return false;
    }

    return true;
}

/**
 * Compare deux tableaux de strings pour vérifier s'ils sont identiques
 */
function areArraysEqual(
    arr1: string[] | undefined,
    arr2: string[] | undefined,
): boolean {
    // Si les deux sont undefined, ils sont égaux
    if (arr1 === undefined && arr2 === undefined) {
        return true;
    }

    // Si l'un est undefined et l'autre non, ils sont différents
    if (arr1 === undefined || arr2 === undefined) {
        return false;
    }

    // Vérifier la longueur
    if (arr1.length !== arr2.length) {
        return false;
    }

    // Comparer chaque élément
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
}
